var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "base-card",
        { attrs: { flat: "" } },
        [
          _c("v-card-title", { staticClass: "d-flex justify-space-between" }, [
            _c("div", [_vm._v("Plans")]),
            _c(
              "div",
              [
                _c(
                  "base-btn",
                  {
                    attrs: {
                      disabled: _vm.$helpers.notHasPermission(
                        _vm.$helpers.PERMISSION_KEYS.ADMIN_BILLING_PLAN_EDIT
                      ),
                    },
                    on: { click: _vm.openCreateDialog },
                  },
                  [_vm._v("New Plan Version")]
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _c("base-card", { attrs: { outlined: "" } }, [
        _c("table", { staticClass: "sites-table" }, [
          _c("thead", [
            _c("tr", [
              _c("th", [_vm._v("#")]),
              _c("th", [_vm._v("Code")]),
              _c("th", [_vm._v("Name")]),
              _c("th", [_vm._v("Version")]),
              _c("th", [_vm._v("Sort Order")]),
              _c("th", [_vm._v("Price (USD)")]),
              _c("th", [_vm._v("Period (Days)")]),
              _c("th", [_vm._v("Status")]),
              _c("th", [_vm._v("Type")]),
              _c("th", [_vm._v("Account")]),
              _c("th", [_vm._v("Actions")]),
            ]),
          ]),
          _c(
            "tbody",
            _vm._l(_vm.plans, function (plan, index) {
              return _c("tr", { key: `plan-${plan.id}` }, [
                _c("td", { staticClass: "width-30px" }, [
                  _c("div", [_vm._v(_vm._s(index + 1))]),
                ]),
                _c("td", [
                  _c("span", { staticClass: "width-100px" }, [
                    _vm._v(_vm._s(plan.code)),
                  ]),
                ]),
                _c("td", [
                  _c("span", { staticClass: "width-150px" }, [
                    _vm._v(_vm._s(plan.name)),
                  ]),
                ]),
                _c("td", [
                  _c("span", { staticClass: "width-50px" }, [
                    _vm._v(_vm._s(plan.version)),
                  ]),
                ]),
                _c("td", [
                  _c("span", { staticClass: "width-50px" }, [
                    _vm._v(_vm._s(plan.sortOrder ?? 0)),
                  ]),
                ]),
                _c("td", [
                  _c("span", { staticClass: "width-100px" }, [
                    _vm._v(_vm._s(_vm.formatPrice(plan.priceUsd, "USD"))),
                  ]),
                ]),
                _c("td", [
                  _c("span", { staticClass: "width-100px" }, [
                    _vm._v(_vm._s(plan.periodDays ?? 30)),
                  ]),
                ]),
                _c(
                  "td",
                  [
                    _c(
                      "v-chip",
                      {
                        attrs: {
                          "x-small": "",
                          color: plan.isActive ? "green" : "grey",
                          dark: "",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(plan.isActive ? "Active" : "Inactive") +
                            " "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _c(
                  "td",
                  [
                    _c(
                      "v-chip",
                      {
                        attrs: {
                          "x-small": "",
                          color: plan.isPublic ? "blue" : "orange",
                          dark: "",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(plan.isPublic ? "Public" : "Enterprise") +
                            " "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _c("td", [
                  _c("span", { staticClass: "width-150px" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          plan.account?.accountTitle ||
                            plan.account?.accountType ||
                            plan.accountId ||
                            "-"
                        ) +
                        " "
                    ),
                  ]),
                ]),
                _c(
                  "td",
                  {
                    staticClass: "width-200px text-center",
                    staticStyle: { "white-space": "nowrap" },
                  },
                  [
                    _c(
                      "div",
                      [
                        _c(
                          "base-btn",
                          {
                            staticClass: "white--text mr-1 mb-1",
                            attrs: {
                              color: "blue",
                              small: "",
                              disabled: _vm.$helpers.notHasPermission(
                                _vm.$helpers.PERMISSION_KEYS
                                  .ADMIN_BILLING_PLAN_EDIT
                              ),
                            },
                            on: {
                              click: function ($event) {
                                return _vm.openNewVersionDialog(plan)
                              },
                            },
                          },
                          [_vm._v(" New Version ")]
                        ),
                        _c(
                          "base-btn",
                          {
                            staticClass: "white--text mr-1 mb-1",
                            attrs: {
                              color: "error",
                              small: "",
                              disabled:
                                !plan.isActive ||
                                _vm.$helpers.notHasPermission(
                                  _vm.$helpers.PERMISSION_KEYS
                                    .ADMIN_BILLING_PLAN_EDIT
                                ),
                            },
                            on: {
                              click: function ($event) {
                                return _vm.deactivatePlan(plan)
                              },
                            },
                          },
                          [_vm._v(" Deactivate ")]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ])
            }),
            0
          ),
        ]),
        !_vm.plans.length && !_vm.isLoading
          ? _c("div", { staticClass: "text-center py-6" }, [
              _vm._v("No plans found."),
            ])
          : _vm._e(),
      ]),
      _c("base-form", {
        ref: "form",
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ invalid }) {
              return [
                _c(
                  "base-dialog",
                  {
                    attrs: {
                      "content-class": "foex-dialog",
                      name: _vm.dialogName,
                      "max-width": "900px",
                    },
                    on: { close: _vm.closeDialog },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function () {
                            return [_vm._v(" " + _vm._s(_vm.dialogTitle) + " ")]
                          },
                          proxy: true,
                        },
                        {
                          key: "dialogFooter",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                [
                                  _c(
                                    "base-btn",
                                    {
                                      staticClass: "mr-2",
                                      attrs: { text: "" },
                                      on: { click: _vm.closeDialog },
                                    },
                                    [_vm._v("Cancel")]
                                  ),
                                  _c(
                                    "base-btn",
                                    {
                                      staticClass: "white--text",
                                      attrs: {
                                        color: "admin-primary",
                                        disabled: invalid,
                                      },
                                      on: { click: _vm.savePlanVersion },
                                    },
                                    [_vm._v("Save")]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      true
                    ),
                  },
                  [
                    _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "12", md: "4" } },
                          [
                            _c("base-text-field", {
                              attrs: {
                                label: "Code",
                                rules: "required",
                                value: _vm.form.code,
                                disabled: !!_vm.selectedPlan,
                              },
                              on: {
                                "update:value": function ($event) {
                                  return _vm.$set(_vm.form, "code", $event)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          { attrs: { cols: "12", md: "4" } },
                          [
                            _c("base-text-field", {
                              attrs: {
                                label: "Name",
                                rules: "required",
                                value: _vm.form.name,
                              },
                              on: {
                                "update:value": function ($event) {
                                  return _vm.$set(_vm.form, "name", $event)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          { attrs: { cols: "12", md: "4" } },
                          [
                            _c("base-text-field", {
                              attrs: {
                                label: "Price (USD)",
                                type: "number",
                                rules: "required",
                                value: _vm.form.priceUsd,
                              },
                              on: {
                                "update:value": function ($event) {
                                  return _vm.$set(_vm.form, "priceUsd", $event)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          { attrs: { cols: "12", md: "4" } },
                          [
                            _c("base-text-field", {
                              attrs: {
                                label: "Period (Days)",
                                type: "number",
                                rules: "required",
                                value: _vm.form.periodDays,
                              },
                              on: {
                                "update:value": function ($event) {
                                  return _vm.$set(
                                    _vm.form,
                                    "periodDays",
                                    $event
                                  )
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-row",
                      [
                        !_vm.isPublicPlanVersion
                          ? _c(
                              "v-col",
                              { attrs: { cols: "12", md: "4" } },
                              [
                                _c("base-select", {
                                  attrs: {
                                    label: "Account",
                                    rules: "required",
                                    items: _vm.accountOptions,
                                    "item-text": "text",
                                    "item-value": "value",
                                    value: _vm.form.accountId,
                                    clearable: "",
                                  },
                                  on: {
                                    "update:value": function ($event) {
                                      return _vm.$set(
                                        _vm.form,
                                        "accountId",
                                        $event
                                      )
                                    },
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "v-col",
                          { attrs: { cols: "12", md: "4" } },
                          [
                            _c("base-text-field", {
                              attrs: {
                                label: "Max Locations",
                                type: "number",
                                rules: "required",
                                value: _vm.form.maxLocations,
                              },
                              on: {
                                "update:value": function ($event) {
                                  return _vm.$set(
                                    _vm.form,
                                    "maxLocations",
                                    $event
                                  )
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          { attrs: { cols: "12", md: "4" } },
                          [
                            _c("base-text-field", {
                              attrs: {
                                label: "Max Users",
                                type: "number",
                                rules: "required",
                                value: _vm.form.maxUsers,
                              },
                              on: {
                                "update:value": function ($event) {
                                  return _vm.$set(_vm.form, "maxUsers", $event)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "12", md: "4" } },
                          [
                            _c("base-switch", {
                              attrs: {
                                label: "Electric Circuit Module",
                                inputValue: _vm.form.electricCircuitEnabled,
                              },
                              on: {
                                "update:inputValue": function ($event) {
                                  return _vm.$set(
                                    _vm.form,
                                    "electricCircuitEnabled",
                                    $event
                                  )
                                },
                                "update:input-value": function ($event) {
                                  return _vm.$set(
                                    _vm.form,
                                    "electricCircuitEnabled",
                                    $event
                                  )
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          { attrs: { cols: "12", md: "4" } },
                          [
                            _c("base-text-field", {
                              attrs: {
                                label: "Circuit Module Price (USD)",
                                type: "number",
                                value: _vm.form.electricCircuitPriceUsd,
                              },
                              on: {
                                "update:value": function ($event) {
                                  return _vm.$set(
                                    _vm.form,
                                    "electricCircuitPriceUsd",
                                    $event
                                  )
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          { attrs: { cols: "12", md: "4" } },
                          [
                            _c("base-text-field", {
                              attrs: {
                                label: "Additional User Price (USD)",
                                type: "number",
                                value: _vm.form.additionalUserPriceUsd,
                              },
                              on: {
                                "update:value": function ($event) {
                                  return _vm.$set(
                                    _vm.form,
                                    "additionalUserPriceUsd",
                                    $event
                                  )
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }